import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {profileSettingService} from "../../../services/profileSettingService/profileSettingService";
import {setUserData} from "../../../redux/authSlice";
import Loader from "../../../components/common/Loader";
import AchievementsListCard from "../../../components/Achievements/AchievementsListCard";
import {TruncatedHtmlTextContent} from "../../../components/TruncatedHtmlTextContent/TruncatedHtmlTextContent";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs/CustomBreadcrumbs";

const ProfileAchievements = () => {
    // states start
    const loginUserData = useSelector((state) => state?.auth?.auth);
    const [getUserData, setGetUserData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const userData = useSelector((state) => state?.auth?.userData);

    const dispatch = useDispatch();
    // states end

    // useEffect for getting all user data
    useEffect(() => {
        getUserAllData();
    }, []);

    const getUserAllData = async () => {
        try {
            const response = await profileSettingService.getUserProfileData(loginUserData?.id);
            const fetchedUserData = response?.data?.data;
            dispatch(setUserData(fetchedUserData));
            setGetUserData(fetchedUserData);
            setIsLoading(false);
        } catch (error) {
            console.error("API error:", error);
            setIsLoading(false);
        }
    };

    return (
        <>
            <CustomBreadcrumbs
                currentPageTitle='Achievements'
                pages={[
                    {
                        title: 'Profile Settings',
                        to: `/profile-settings`
                    },
                ]}
            />
            {isLoading ? (
                <Loader/>
            ) : (
                <>
                    <div className="mt-4">
                        <AchievementsListCard
                            achievements={userData?.badges}
                            unopenedBadges={userData?.unopened}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default ProfileAchievements;